﻿import { Component } from "@angular/core";

@Component({
    selector: "bo-jub-dashboard",
    templateUrl: "./dashboard.component.html"
})

export class DashboardComponent {

}
